import { SYNC_BACKGROUNDS } from 'actions/Types';
import { withCurrentParams, mapSignedUrlsToSources } from 'actions/utils';

export default () => {
  return withCurrentParams((dispatch, { teamId, eventId, broadcastId }) => {
    const action = {
      type: SYNC_BACKGROUNDS,
      request: async apiClient => {
        const broadcast = await apiClient.broadcast.get(
          teamId,
          eventId,
          broadcastId
        );
        const { backgrounds } = broadcast;
        const mappedBackgrounds = mapSignedUrlsToSources(
          backgrounds,
          apiClient,
          teamId,
          eventId
        );
        return {
          backgrounds: await mappedBackgrounds
        };
      }
    };
    dispatch(action);
  });
};
